let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cEFRt")).then(() => parcelRequire('8DQk2'));